var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.015 11.41a.6.6 0 0 0 .19.348c.172.17.418.22.652.133.113-.043.255-.185 3.8-3.838a654 654 0 0 1 3.696-3.794c.008 0 .018 3.888.02 8.638l.006 8.638.046.09c.145.28.414.42.693.362a.64.64 0 0 0 .459-.363l.046-.089.005-8.638c.003-4.75.012-8.638.02-8.638s1.672 1.708 3.697 3.794c3.585 3.693 3.685 3.795 3.804 3.84.37.14.771-.097.842-.5a.75.75 0 0 0-.048-.398c-.043-.097-8.502-8.836-8.626-8.912a.66.66 0 0 0-.612-.017c-.072.037-8.513 8.726-8.596 8.85a.63.63 0 0 0-.094.493",
    clipRule: "evenodd"
  })));
};
export default SvgArrowUp;